import React from 'react';

const AddfluenceTheme = {
  headerLogo: {
    src: '/themes/theme/addfluence/logo.png',
    alt: 'Addfluence',
  },
  darkLogo: {
    src: '/themes/theme/addfluence/logo.png',
    alt: 'Addfluence',
  },
  headerStyle: {
    backgroundImage: 'linear-gradient(to right, #f373a1, #ff9f1e)',
    borderBottom: '2px solid #000',
  },
  linkStyle: {
    color: '#000',
    fontWeight: 800,
    fontSize: '120%',
  },
  isLightOnDark: false,
  loginMessage: (
    <div style={{ height: '400px', padding: '10px', backgroundColor: '#ffdaa7' }}>
      <img width="300" src="/themes/theme/addfluence/logo.png" alt="Addfluence" style={{ marginTop: 150 }} />
    </div>
  ),
  shareSite: 'https://addfluencer.dyzio.co',
};

export default AddfluenceTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/addfluence.js
 **/